import React from 'react';
import  { Carousel } from 'react-responsive-carousel';
import CarouselItem from './CarouselItem';
import * as actionsCreators from '../../actions/replaceCarouselData';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';


class CarouslSlides extends React.Component{
    constructor(props){
        super(props);
        this.state={
            selectedItem:0
        };
    }

    renderCarousel(){
       return this.props.carousels.map((single,index) => <CarouselItem {...single} key={index}/>);
    }
    dispatchChange=(i,element)=>{
        this.setState({
            selectedItem:i
        });
        this.props.replaceCarouselData(i);
    }
    
    
    render(){
        return(
            <div className="carousel">  
            <Carousel autoPlay={true}
            selectedItem={this.state.selectedItem} 
            interval={10000}
             showThumbs={false}
              infiniteLoop={true}
              showStatus={false}
              onChange={(i)=>this.dispatchChange(i)}
              dynamicHeight={true}
             >
              {this.renderCarousel()}
            </Carousel>
            </div> 
        );
    }
}

function mapStateToProps(state,props){
    return{
        carousels:state.carousels
    }
}

function mapDispachToProps(dispatch){ 
    return  bindActionCreators(actionsCreators,dispatch);
}

export default connect(mapStateToProps,mapDispachToProps) (CarouslSlides);


// WEBPACK FOOTER //
// ./src/components/home/CarouselSlides.js